var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h1',[_vm._v("AQI Comparison")]),_c('div',{staticStyle:{"width":"400px"}},[_c('doughnut-chart',{attrs:{"chart-data":_vm.doughnutdatacollection}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }